module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "103a":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	const pnglib = __webpack_require__(1);
	const hsl2rgb = __webpack_require__(2);

	// The random number is a js implementation of the Xorshift PRNG
	const randseed = new Array(4); // Xorshift: [x, y, z, w] 32 bit values

	function seedrand(seed) {
	  for (let i = 0; i < randseed.length; i++) {
	    randseed[i] = 0;
	  }
	  for (let i = 0; i < seed.length; i++) {
	    randseed[i % 4] = (randseed[i % 4] << 5) - randseed[i % 4] + seed.charCodeAt(i);
	  }
	}

	function rand() {
	  // based on Java's String.hashCode(), expanded to 4 32bit values
	  const t = randseed[0] ^ (randseed[0] << 11);

	  randseed[0] = randseed[1];
	  randseed[1] = randseed[2];
	  randseed[2] = randseed[3];
	  randseed[3] = randseed[3] ^ (randseed[3] >> 19) ^ t ^ (t >> 8);

	  return (randseed[3] >>> 0) / (1 << 31 >>> 0);
	}

	function createColor() {
	  //saturation is the whole color spectrum
	  const h = Math.floor(rand() * 360);
	  //saturation goes from 40 to 100, it avoids greyish colors
	  const s = rand() * 60 + 40;
	  //lightness can be anything from 0 to 100, but probabilities are a bell curve around 50%
	  const l = (rand() + rand() + rand() + rand()) * 25 ;

	  return [h / 360, s / 100, l / 100];
	}

	function createImageData(size) {
	  const width = size; // Only support square icons for now
	  const height = size;

	  const dataWidth = Math.ceil(width / 2);
	  const mirrorWidth = width - dataWidth;

	  const data = [];
	  for (let y = 0; y < height; y++) {
	    let row = [];
	    for (let x = 0; x < dataWidth; x++) {
	      // this makes foreground and background color to have a 43% (1/2.3) probability
	      // spot color has 13% chance
	      row[x] = Math.floor(rand() * 2.3);
	    }
	    const r = row.slice(0, mirrorWidth).reverse();
	    row = row.concat(r);

	    for (let i = 0; i < row.length; i++) {
	      data.push(row[i]);
	    }
	  }

	  return data;
	}

	// Modifies the passed PNG to fill in a specified rectangle
	function fillRect(png, x, y, w, h, color) {
	  for(let i = 0; i < w; i++) {
	    for (let j = 0; j < h; j++) {
	      png.buffer[png.index(x + i, y + j)] = color;
	    }
	  }
	}

	function buildOpts(opts) {
	  if (!opts.seed) {
	    throw new Error('No seed provided');
	  }

	  seedrand(opts.seed);

	  return Object.assign({
	    size: 8,
	    scale: 16,
	    color: createColor(),
	    bgcolor: createColor(),
	    spotcolor: createColor(),
	  }, opts)
	}

	function makeBlockie(address) {
	  const opts = buildOpts({ seed: address.toLowerCase() });

	  const imageData = createImageData(opts.size);
	  const width = Math.sqrt(imageData.length);

	  const p = new pnglib(opts.size * opts.scale, opts.size * opts.scale, 3);
	  const bgcolor = p.color(...hsl2rgb(...opts.bgcolor));
	  const color = p.color(...hsl2rgb(...opts.color));
	  const spotcolor = p.color(...hsl2rgb(...opts.spotcolor));

	  for (let i = 0; i < imageData.length; i++) {
	    const row = Math.floor(i / width);
	    const col = i % width;
	    // if data is 0, leave the background
	    if (imageData[i]) {
	      // if data is 2, choose spot color, if 1 choose foreground
	      const pngColor = imageData[i] == 1 ? color : spotcolor;
	      fillRect(p, col * opts.scale, row * opts.scale, opts.scale, opts.scale, pngColor);
	    }
	  }
	  return `data:image/png;base64,${p.getBase64()}`;
	}

	module.exports = makeBlockie;


/***/ },
/* 1 */
/***/ function(module, exports) {

	/**
	 * A handy class to calculate color values.
	 *
	 * @version 1.0
	 * @author Robert Eisele <robert@xarg.org>
	 * @copyright Copyright (c) 2010, Robert Eisele
	 * @link http://www.xarg.org/2010/03/generate-client-side-png-files-using-javascript/
	 * @license http://www.opensource.org/licenses/bsd-license.php BSD License
	 *
	 */

	// Modified by George Chan <gchan@21cn.com>

	// Further modified by Will O'B <@wbobeirne> to make it
	// UglifyJS and "use strict"; friendly

	module.exports = function(width,height,depth) {


	    // helper functions for that ctx
	    function write(buffer, offs) {
	        for (var i = 2; i < arguments.length; i++) {
	            for (var j = 0; j < arguments[i].length; j++) {
	                buffer[offs++] = arguments[i].charAt(j);
	            }
	        }
	    }

	    function byte2(w) {
	        return String.fromCharCode((w >> 8) & 255, w & 255);
	    }

	    function byte4(w) {
	        return String.fromCharCode((w >> 24) & 255, (w >> 16) & 255, (w >> 8) & 255, w & 255);
	    }

	    function byte2lsb(w) {
	        return String.fromCharCode(w & 255, (w >> 8) & 255);
	    }

	    this.width   = width;
	    this.height  = height;
	    this.depth   = depth;

	    // pixel data and row filter identifier size
	    this.pix_size = height * (width + 1);

	    // deflate header, pix_size, block headers, adler32 checksum
	    this.data_size = 2 + this.pix_size + 5 * Math.floor((0xfffe + this.pix_size) / 0xffff) + 4;

	    // offsets and sizes of Png chunks
	    this.ihdr_offs = 0; // IHDR offset and size
	    this.ihdr_size = 4 + 4 + 13 + 4;
	    this.plte_offs = this.ihdr_offs + this.ihdr_size; // PLTE offset and size
	    this.plte_size = 4 + 4 + 3 * depth + 4;
	    this.trns_offs = this.plte_offs + this.plte_size; // tRNS offset and size
	    this.trns_size = 4 + 4 + depth + 4;
	    this.idat_offs = this.trns_offs + this.trns_size; // IDAT offset and size
	    this.idat_size = 4 + 4 + this.data_size + 4;
	    this.iend_offs = this.idat_offs + this.idat_size; // IEND offset and size
	    this.iend_size = 4 + 4 + 4;
	    this.buffer_size  = this.iend_offs + this.iend_size; // total PNG size

	    this.buffer  = new Array();
	    this.palette = new Object();
	    this.pindex  = 0;

	    var _crc32 = new Array();

	    // initialize buffer with zero bytes
	    for (var i = 0; i < this.buffer_size; i++) {
	        this.buffer[i] = "\x00";
	    }

	    // initialize non-zero elements
	    write(this.buffer, this.ihdr_offs, byte4(this.ihdr_size - 12), 'IHDR', byte4(width), byte4(height), "\x08\x03");
	    write(this.buffer, this.plte_offs, byte4(this.plte_size - 12), 'PLTE');
	    write(this.buffer, this.trns_offs, byte4(this.trns_size - 12), 'tRNS');
	    write(this.buffer, this.idat_offs, byte4(this.idat_size - 12), 'IDAT');
	    write(this.buffer, this.iend_offs, byte4(this.iend_size - 12), 'IEND');

	    // initialize deflate header
	    var header = ((8 + (7 << 4)) << 8) | (3 << 6);
	    header+= 31 - (header % 31);

	    write(this.buffer, this.idat_offs + 8, byte2(header));

	    // initialize deflate block headers
	    for (var i = 0; (i << 16) - 1 < this.pix_size; i++) {
	        var size, bits;
	        if (i + 0xffff < this.pix_size) {
	            size = 0xffff;
	            bits = "\x00";
	        } else {
	            size = this.pix_size - (i << 16) - i;
	            bits = "\x01";
	        }
	        write(this.buffer, this.idat_offs + 8 + 2 + (i << 16) + (i << 2), bits, byte2lsb(size), byte2lsb(~size));
	    }

	    /* Create crc32 lookup table */
	    for (var i = 0; i < 256; i++) {
	        var c = i;
	        for (var j = 0; j < 8; j++) {
	            if (c & 1) {
	                c = -306674912 ^ ((c >> 1) & 0x7fffffff);
	            } else {
	                c = (c >> 1) & 0x7fffffff;
	            }
	        }
	        _crc32[i] = c;
	    }

	    // compute the index into a png for a given pixel
	    this.index = function(x,y) {
	        var i = y * (this.width + 1) + x + 1;
	        var j = this.idat_offs + 8 + 2 + 5 * Math.floor((i / 0xffff) + 1) + i;
	        return j;
	    }

	    // convert a color and build up the palette
	    this.color = function(red, green, blue, alpha) {

	        alpha = alpha >= 0 ? alpha : 255;
	        var color = (((((alpha << 8) | red) << 8) | green) << 8) | blue;

	        if (typeof this.palette[color] == "undefined") {
	            if (this.pindex == this.depth) return "\x00";

	            var ndx = this.plte_offs + 8 + 3 * this.pindex;

	            this.buffer[ndx + 0] = String.fromCharCode(red);
	            this.buffer[ndx + 1] = String.fromCharCode(green);
	            this.buffer[ndx + 2] = String.fromCharCode(blue);
	            this.buffer[this.trns_offs+8+this.pindex] = String.fromCharCode(alpha);

	            this.palette[color] = String.fromCharCode(this.pindex++);
	        }
	        return this.palette[color];
	    }

	    // output a PNG string, Base64 encoded
	    this.getBase64 = function() {

	        var s = this.getDump();

	        var ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	        var c1, c2, c3, e1, e2, e3, e4;
	        var l = s.length;
	        var i = 0;
	        var r = "";

	        do {
	            c1 = s.charCodeAt(i);
	            e1 = c1 >> 2;
	            c2 = s.charCodeAt(i+1);
	            e2 = ((c1 & 3) << 4) | (c2 >> 4);
	            c3 = s.charCodeAt(i+2);
	            if (l < i+2) { e3 = 64; } else { e3 = ((c2 & 0xf) << 2) | (c3 >> 6); }
	            if (l < i+3) { e4 = 64; } else { e4 = c3 & 0x3f; }
	            r+= ch.charAt(e1) + ch.charAt(e2) + ch.charAt(e3) + ch.charAt(e4);
	        } while ((i+= 3) < l);
	        return r;
	    }

	    // output a PNG string
	    this.getDump = function() {
	        // compute adler32 of output pixels + row filter bytes
	        var BASE = 65521; /* largest prime smaller than 65536 */
	        var NMAX = 5552; /* NMAX is the largest n such that 255n(n+1)/2 + (n+1)(BASE-1) <= 2^32-1 */
	        var s1 = 1;
	        var s2 = 0;
	        var n = NMAX;

	        for (var y = 0; y < this.height; y++) {
	            for (var x = -1; x < this.width; x++) {
	                s1+= this.buffer[this.index(x, y)].charCodeAt(0);
	                s2+= s1;
	                if ((n-= 1) == 0) {
	                    s1%= BASE;
	                    s2%= BASE;
	                    n = NMAX;
	                }
	            }
	        }
	        s1%= BASE;
	        s2%= BASE;
	        write(this.buffer, this.idat_offs + this.idat_size - 8, byte4((s2 << 16) | s1));

	        // compute crc32 of the PNG chunks
	        function crc32(png, offs, size) {
	            var crc = -1;
	            for (var i = 4; i < size-4; i += 1) {
	                crc = _crc32[(crc ^ png[offs+i].charCodeAt(0)) & 0xff] ^ ((crc >> 8) & 0x00ffffff);
	            }
	            write(png, offs+size-4, byte4(crc ^ -1));
	        }

	        crc32(this.buffer, this.ihdr_offs, this.ihdr_size);
	        crc32(this.buffer, this.plte_offs, this.plte_size);
	        crc32(this.buffer, this.trns_offs, this.trns_size);
	        crc32(this.buffer, this.idat_offs, this.idat_size);
	        crc32(this.buffer, this.iend_offs, this.iend_size);

	        // convert PNG to string
	        return "\x89PNG\r\n\x1a\n" + this.buffer.join('');
	    }
	};


/***/ },
/* 2 */
/***/ function(module, exports) {

	// https://stackoverflow.com/questions/2353211/hsl-to-rgb-color-conversion
	/**
	 * Converts an HSL color value to RGB. Conversion formula
	 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
	 * Assumes h, s, and l are contained in the set [0, 1] and
	 * returns r, g, and b in the set [0, 255].
	 *
	 * @param   {number}  h       The hue
	 * @param   {number}  s       The saturation
	 * @param   {number}  l       The lightness
	 * @return  {Array}           The RGB representation
	 */

	 function hue2rgb(p, q, t) {
	   if(t < 0) t += 1;
	   if(t > 1) t -= 1;
	   if(t < 1/6) return p + (q - p) * 6 * t;
	   if(t < 1/2) return q;
	   if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	   return p;
	 }

	function hsl2rgb(h, s, l){
	  let r, g, b;

	  if (s == 0) {
	    r = g = b = l; // achromatic
	  } else {
	    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	    const p = 2 * l - q;
	    r = hue2rgb(p, q, h + 1/3);
	    g = hue2rgb(p, q, h);
	    b = hue2rgb(p, q, h - 1/3);
	  }

	  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255), 255];
	}

	module.exports = hsl2rgb;


/***/ }
/******/ ])
});
;

/***/ }),

/***/ "13be":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var filters_namespaceObject = {};
__webpack_require__.r(filters_namespaceObject);
__webpack_require__.d(filters_namespaceObject, "urlChainExplorer", function() { return urlChainExplorer; });
__webpack_require__.d(filters_namespaceObject, "urlIpfsExplorer", function() { return urlIpfsExplorer; });
var mixins_namespaceObject = {};
__webpack_require__.r(mixins_namespaceObject);
__webpack_require__.d(mixins_namespaceObject, "form", function() { return mixins_form; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/button/Button.vue?vue&type=template&id=ab2f253c&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    { 'container-full': _vm.fullWidth },
    _vm.size ? ("btn-" + _vm.size) : null,
    ("btn-" + _vm.color)
  ],on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/button/Button.vue?vue&type=template&id=ab2f253c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/button/Button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Buttonvue_type_script_lang_js_ = ({
  props: {
    fullWidth: {
      type: Boolean,
      default: false
    },

    /**
     * Variants: 'big' | 'sm'
     */
    size: {
      type: String,
      validator: prop => ["big", "sm"].includes(prop),
      require: false
    },

    /**
     * Variants: 'green' | 'blue'
     */
    color: {
      type: String,
      validator: prop => ["green", "blue"].includes(prop),
      default: "blue"
    }
  }
});
// CONCATENATED MODULE: ./src/components/button/Button.vue?vue&type=script&lang=js&
 /* harmony default export */ var button_Buttonvue_type_script_lang_js_ = (Buttonvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/button/Button.vue





/* normalize component */

var Button_component = normalizeComponent(
  button_Buttonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Button = (Button_component.exports);
// CONCATENATED MODULE: ./src/components/button/index.js

/* harmony default export */ var components_button = (Button);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/card/Card.vue?vue&type=template&id=4ceb390f&
var Cardvue_type_template_id_4ceb390f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-light"},[_vm._t("default")],2)}
var Cardvue_type_template_id_4ceb390f_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/card/Card.vue?vue&type=template&id=4ceb390f&

// CONCATENATED MODULE: ./src/components/card/Card.vue

var script = {}


/* normalize component */

var Card_component = normalizeComponent(
  script,
  Cardvue_type_template_id_4ceb390f_render,
  Cardvue_type_template_id_4ceb390f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Card = (Card_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/card/CardTitle.vue?vue&type=template&id=7a365896&
var CardTitlevue_type_template_id_7a365896_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_vm._t("default")],2)}
var CardTitlevue_type_template_id_7a365896_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/card/CardTitle.vue?vue&type=template&id=7a365896&

// CONCATENATED MODULE: ./src/components/card/CardTitle.vue

var CardTitle_script = {}


/* normalize component */

var CardTitle_component = normalizeComponent(
  CardTitle_script,
  CardTitlevue_type_template_id_7a365896_render,
  CardTitlevue_type_template_id_7a365896_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CardTitle = (CardTitle_component.exports);
// CONCATENATED MODULE: ./src/components/card/index.js


/* harmony default export */ var card = (Card);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/FormSection.vue?vue&type=template&id=572c96ce&
var FormSectionvue_type_template_id_572c96ce_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"form-section-title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var FormSectionvue_type_template_id_572c96ce_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/form/FormSection.vue?vue&type=template&id=572c96ce&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/FormSection.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
/* harmony default export */ var FormSectionvue_type_script_lang_js_ = ({
  props: {
    title: String
  }
});
// CONCATENATED MODULE: ./src/components/form/FormSection.vue?vue&type=script&lang=js&
 /* harmony default export */ var form_FormSectionvue_type_script_lang_js_ = (FormSectionvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/form/FormSection.vue





/* normalize component */

var FormSection_component = normalizeComponent(
  form_FormSectionvue_type_script_lang_js_,
  FormSectionvue_type_template_id_572c96ce_render,
  FormSectionvue_type_template_id_572c96ce_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FormSection = (FormSection_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/FormField.vue?vue&type=template&id=0ff4ff81&
var FormFieldvue_type_template_id_0ff4ff81_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item form-line-label"},[_vm._t("default")],2)}
var FormFieldvue_type_template_id_0ff4ff81_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/form/FormField.vue?vue&type=template&id=0ff4ff81&

// CONCATENATED MODULE: ./src/components/form/FormField.vue

var FormField_script = {}


/* normalize component */

var FormField_component = normalizeComponent(
  FormField_script,
  FormFieldvue_type_template_id_0ff4ff81_render,
  FormFieldvue_type_template_id_0ff4ff81_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FormField = (FormField_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/FieldLabel.vue?vue&type=template&id=bb9d72b6&
var FieldLabelvue_type_template_id_bb9d72b6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._t("default"),_vm._v(": "),(_vm.isError)?_c('span',{staticClass:"input-msg"},[_vm._v(_vm._s(_vm.msgError))]):_vm._e()],2)}
var FieldLabelvue_type_template_id_bb9d72b6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/form/FieldLabel.vue?vue&type=template&id=bb9d72b6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/FieldLabel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
/* harmony default export */ var FieldLabelvue_type_script_lang_js_ = ({
  props: {
    msgError: {
      type: String,
      default: "Check if data correct, please."
    },
    isError: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/form/FieldLabel.vue?vue&type=script&lang=js&
 /* harmony default export */ var form_FieldLabelvue_type_script_lang_js_ = (FieldLabelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/form/FieldLabel.vue





/* normalize component */

var FieldLabel_component = normalizeComponent(
  form_FieldLabelvue_type_script_lang_js_,
  FieldLabelvue_type_template_id_bb9d72b6_render,
  FieldLabelvue_type_template_id_bb9d72b6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FieldLabel = (FieldLabel_component.exports);
// CONCATENATED MODULE: ./src/components/form/index.js




// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/icon/Icon.vue?vue&type=template&id=ab6be024&
var Iconvue_type_template_id_ab6be024_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[("i-" + _vm.name), { left: _vm.left, right: _vm.right }]})}
var Iconvue_type_template_id_ab6be024_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/icon/Icon.vue?vue&type=template&id=ab6be024&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/icon/Icon.vue?vue&type=script&lang=js&
//
//
//
//
/* harmony default export */ var Iconvue_type_script_lang_js_ = ({
  props: {
    name: {
      type: String
    }
  }
});
// CONCATENATED MODULE: ./src/components/icon/Icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var icon_Iconvue_type_script_lang_js_ = (Iconvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/icon/Icon.vue





/* normalize component */

var Icon_component = normalizeComponent(
  icon_Iconvue_type_script_lang_js_,
  Iconvue_type_template_id_ab6be024_render,
  Iconvue_type_template_id_ab6be024_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Icon = (Icon_component.exports);
// CONCATENATED MODULE: ./src/components/icon/index.js

/* harmony default export */ var icon = (Icon);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/label/Label.vue?vue&type=template&id=6dbd1cf9&
var Labelvue_type_template_id_6dbd1cf9_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label",class:[("label-" + _vm.color), { 't-sm': _vm.isSmall }]},[_vm._t("default")],2)}
var Labelvue_type_template_id_6dbd1cf9_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/label/Label.vue?vue&type=template&id=6dbd1cf9&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/label/Label.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var Labelvue_type_script_lang_js_ = ({
  props: {
    /**
     * Variants: 'green' | 'violet'
     */
    color: {
      type: String,
      validator: prop => ["green", "violet", "orange"].includes(prop),
      default: "green"
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/label/Label.vue?vue&type=script&lang=js&
 /* harmony default export */ var label_Labelvue_type_script_lang_js_ = (Labelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/label/Label.vue





/* normalize component */

var Label_component = normalizeComponent(
  label_Labelvue_type_script_lang_js_,
  Labelvue_type_template_id_6dbd1cf9_render,
  Labelvue_type_template_id_6dbd1cf9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Label = (Label_component.exports);
// CONCATENATED MODULE: ./src/components/label/index.js

/* harmony default export */ var label = (Label);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/Layout.vue?vue&type=template&id=cef7f08e&
var Layoutvue_type_template_id_cef7f08e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"content-in"},[_vm._t("default")],2)])}
var Layoutvue_type_template_id_cef7f08e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/layout/Layout.vue?vue&type=template&id=cef7f08e&

// CONCATENATED MODULE: ./src/components/layout/Layout.vue

var Layout_script = {}


/* normalize component */

var Layout_component = normalizeComponent(
  Layout_script,
  Layoutvue_type_template_id_cef7f08e_render,
  Layoutvue_type_template_id_cef7f08e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Layout = (Layout_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/Sidebar.vue?vue&type=template&id=1f0bb830&
var Sidebarvue_type_template_id_1f0bb830_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar flexcols"},[_c('div',{staticClass:"sidebar-col sidebar-col--sm"},[_c('div',{staticClass:"sidebar-col-in"},[_vm._t("default")],2)])])}
var Sidebarvue_type_template_id_1f0bb830_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/layout/Sidebar.vue?vue&type=template&id=1f0bb830&

// CONCATENATED MODULE: ./src/components/layout/Sidebar.vue

var Sidebar_script = {}


/* normalize component */

var Sidebar_component = normalizeComponent(
  Sidebar_script,
  Sidebarvue_type_template_id_1f0bb830_render,
  Sidebarvue_type_template_id_1f0bb830_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Sidebar = (Sidebar_component.exports);
// CONCATENATED MODULE: ./src/components/layout/index.js


/* harmony default export */ var layout = (Layout);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/linkExplorer/ChainExplorer.vue?vue&type=template&id=18185567&
var ChainExplorervue_type_template_id_18185567_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.href,"target":"_blank","title":_vm.address}},[_vm._t("default",[(_vm.isAvatar)?_c('Avatar',{staticClass:"avatar-small align-vertical m-r-10",attrs:{"address":_vm.address}}):_vm._e(),_c('b',[_vm._v(_vm._s(_vm.label))])])],2)}
var ChainExplorervue_type_template_id_18185567_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/linkExplorer/ChainExplorer.vue?vue&type=template&id=18185567&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/linkExplorer/Avatar.vue?vue&type=template&id=ae463570&
var Avatarvue_type_template_id_ae463570_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":""}}):_vm._e()}
var Avatarvue_type_template_id_ae463570_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/linkExplorer/Avatar.vue?vue&type=template&id=ae463570&

// EXTERNAL MODULE: ./node_modules/ethereum-blockies-base64/dist/main.js
var main = __webpack_require__("103a");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/linkExplorer/Avatar.vue?vue&type=script&lang=js&
//
//
//
//

/* harmony default export */ var Avatarvue_type_script_lang_js_ = ({
  props: {
    address: {
      type: String
    }
  },
  computed: {
    src: function () {
      return this.address ? main_default()(this.address) : "";
    }
  }
});
// CONCATENATED MODULE: ./src/components/linkExplorer/Avatar.vue?vue&type=script&lang=js&
 /* harmony default export */ var linkExplorer_Avatarvue_type_script_lang_js_ = (Avatarvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/linkExplorer/Avatar.vue





/* normalize component */

var Avatar_component = normalizeComponent(
  linkExplorer_Avatarvue_type_script_lang_js_,
  Avatarvue_type_template_id_ae463570_render,
  Avatarvue_type_template_id_ae463570_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Avatar = (Avatar_component.exports);
// CONCATENATED MODULE: ./src/tools/filters.js
function urlChainExplorer(address, type = "address", chainid = 1) {
  let domain = "etherscan.io";

  if (type === "") {
    type = "address";
  }

  if (chainid === 4451) {
    domain = "explorer.aira.life";

    if (type === "address") {
      type = "addr";
    }
  } else {
    let chain = "";

    if (chainid === 4) {
      chain = "rinkeby.";
    }

    domain = chain + domain;
  }

  return `https://${domain}/${type}/${address}`;
}
function urlIpfsExplorer(hash, type = "ipfs") {
  const domain = "ipfs.io";

  if (type === "") {
    type = "ipfs";
  }

  return `https://${domain}/${type}/${hash}`;
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/linkExplorer/ChainExplorer.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ChainExplorervue_type_script_lang_js_ = ({
  props: {
    chainid: {
      type: Number,
      default: 1
    },
    address: {
      type: String,
      require: true
    },
    category: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    isAvatar: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Avatar: Avatar
  },
  computed: {
    href: function () {
      return urlChainExplorer(this.address, this.category, this.chainid);
    },
    label: function () {
      return this.text ? this.text : this.address.slice(0, 6) + "..." + this.address.slice(-4);
    }
  }
});
// CONCATENATED MODULE: ./src/components/linkExplorer/ChainExplorer.vue?vue&type=script&lang=js&
 /* harmony default export */ var linkExplorer_ChainExplorervue_type_script_lang_js_ = (ChainExplorervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/linkExplorer/ChainExplorer.vue





/* normalize component */

var ChainExplorer_component = normalizeComponent(
  linkExplorer_ChainExplorervue_type_script_lang_js_,
  ChainExplorervue_type_template_id_18185567_render,
  ChainExplorervue_type_template_id_18185567_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ChainExplorer = (ChainExplorer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/linkExplorer/IpfsExplorer.vue?vue&type=template&id=ebba4516&
var IpfsExplorervue_type_template_id_ebba4516_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.href,"target":"_blank","title":_vm.hash}},[_vm._t("default",[_c('b',[_vm._v(_vm._s(_vm.label))])])],2)}
var IpfsExplorervue_type_template_id_ebba4516_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/linkExplorer/IpfsExplorer.vue?vue&type=template&id=ebba4516&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/linkExplorer/IpfsExplorer.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//

/* harmony default export */ var IpfsExplorervue_type_script_lang_js_ = ({
  props: {
    chainid: {
      type: Number,
      default: 1
    },
    hash: {
      type: String,
      require: true
    },
    type: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    }
  },
  computed: {
    href: function () {
      return urlIpfsExplorer(this.hash, this.type);
    },
    label: function () {
      return this.text ? this.text : this.hash.slice(0, 6) + "..." + this.hash.slice(-4);
    }
  }
});
// CONCATENATED MODULE: ./src/components/linkExplorer/IpfsExplorer.vue?vue&type=script&lang=js&
 /* harmony default export */ var linkExplorer_IpfsExplorervue_type_script_lang_js_ = (IpfsExplorervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/linkExplorer/IpfsExplorer.vue





/* normalize component */

var IpfsExplorer_component = normalizeComponent(
  linkExplorer_IpfsExplorervue_type_script_lang_js_,
  IpfsExplorervue_type_template_id_ebba4516_render,
  IpfsExplorervue_type_template_id_ebba4516_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var IpfsExplorer = (IpfsExplorer_component.exports);
// CONCATENATED MODULE: ./src/components/linkExplorer/index.js




// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/loader/Loader.vue?vue&type=template&id=2cb8f014&
var Loadervue_type_template_id_2cb8f014_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-ring"})}
var Loadervue_type_template_id_2cb8f014_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/loader/Loader.vue?vue&type=template&id=2cb8f014&

// CONCATENATED MODULE: ./src/components/loader/Loader.vue

var Loader_script = {}


/* normalize component */

var Loader_component = normalizeComponent(
  Loader_script,
  Loadervue_type_template_id_2cb8f014_render,
  Loadervue_type_template_id_2cb8f014_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Loader = (Loader_component.exports);
// CONCATENATED MODULE: ./src/components/loader/index.js

/* harmony default export */ var loader = (Loader);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/overlay/Overlay.vue?vue&type=template&id=c6a08af4&
var Overlayvue_type_template_id_c6a08af4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-basic"},[_c('section',{staticClass:"loading-container"},[_c('div',{staticClass:"loading-logo"},[_c('img',{staticStyle:{"width":"150px"},attrs:{"alt":"dApp logo","src":_vm.logo}})]),_c('div',{staticClass:"t-uppercase t-lg tcolor-violet"},[_vm._v("robonomics.network")]),_vm._t("default")],2)])}
var Overlayvue_type_template_id_c6a08af4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/overlay/Overlay.vue?vue&type=template&id=c6a08af4&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/overlay/Overlay.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Overlayvue_type_script_lang_js_ = ({
  props: {
    logo: String
  }
});
// CONCATENATED MODULE: ./src/components/overlay/Overlay.vue?vue&type=script&lang=js&
 /* harmony default export */ var overlay_Overlayvue_type_script_lang_js_ = (Overlayvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/overlay/Overlay.vue





/* normalize component */

var Overlay_component = normalizeComponent(
  overlay_Overlayvue_type_script_lang_js_,
  Overlayvue_type_template_id_c6a08af4_render,
  Overlayvue_type_template_id_c6a08af4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Overlay = (Overlay_component.exports);
// CONCATENATED MODULE: ./src/components/overlay/index.js

/* harmony default export */ var overlay = (Overlay);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7d5cae25-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/window/Window.vue?vue&type=template&id=3449e247&
var Windowvue_type_template_id_3449e247_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-light window"},[_c('div',{staticClass:"window-head"},[_vm._t("header"),_c('a',{staticClass:"window-head-toggle",attrs:{"href":"javascript:;"},on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.icon))])],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"window-content"},[_vm._t("default")],2)])}
var Windowvue_type_template_id_3449e247_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/window/Window.vue?vue&type=template&id=3449e247&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/window/Window.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Windowvue_type_script_lang_js_ = ({
  props: {
    initShow: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isShow: this.initShow
    };
  },

  computed: {
    icon: function () {
      return this.isShow ? "–" : "+";
    }
  },
  methods: {
    toggle() {
      this.isShow = !this.isShow;
    }

  }
});
// CONCATENATED MODULE: ./src/components/window/Window.vue?vue&type=script&lang=js&
 /* harmony default export */ var window_Windowvue_type_script_lang_js_ = (Windowvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/window/Window.vue





/* normalize component */

var Window_component = normalizeComponent(
  window_Windowvue_type_script_lang_js_,
  Windowvue_type_template_id_3449e247_render,
  Windowvue_type_template_id_3449e247_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Window = (Window_component.exports);
// CONCATENATED MODULE: ./src/components/window/index.js

/* harmony default export */ var components_window = (Window);
// CONCATENATED MODULE: ./src/components/index.js










/* harmony default export */ var components = ({
  Button: components_button,
  Card: card,
  CardTitle: CardTitle,
  FormField: FormField,
  FormSection: FormSection,
  Icon: icon,
  FieldLabel: FieldLabel,
  Label: label,
  Layout: layout,
  Sidebar: Sidebar,
  ChainExplorer: ChainExplorer,
  IpfsExplorer: IpfsExplorer,
  Avatar: Avatar,
  Loader: loader,
  Overlay: overlay,
  Window: components_window
});
// CONCATENATED MODULE: ./src/tools/validators.js
function require(value) {
  return minLength(1)(value);
}

function number(value) {
  return !require(value) || !isNaN(parseFloat(value)) && isFinite(value);
}

function min(minValue) {
  return function (value) {
    return !require(value) || parseFloat(value) >= minValue;
  };
}

function max(maxValue) {
  return function (value) {
    return !require(value) || parseFloat(value) <= maxValue;
  };
}

function between(minValue, maxValue) {
  const minFn = min(minValue);
  const maxFn = max(maxValue);
  return function (value) {
    return !require(value) || minFn(value) && maxFn(value);
  };
}

function validators_length(length) {
  return function (value) {
    return value.toString().length === length;
  };
}

function minLength(min) {
  return function (value) {
    return value.toString().length >= min;
  };
}

function maxLength(max) {
  return function (value) {
    return value.toString().length <= max;
  };
}

function hashIpfs(value) {
  return !require(value) || validators_length(46)(value);
}

/* harmony default export */ var validators = ({
  require,
  number,
  min,
  max,
  between,
  length: validators_length,
  minLength,
  maxLength,
  hashIpfs
});
// CONCATENATED MODULE: ./src/mixins/form.js


const isFunction = function (obj) {
  return !!(obj && obj.constructor && obj.call && obj.apply);
};

/* harmony default export */ var mixins_form = ({
  data() {
    return {
      fields: {// example: {
        //   value: "",
        //   rules: [
        //     "require",
        //     "hash",
        //     validators.between(1, 3)
        //   ],
        //   error: false
        // }
      },
      error: false
    };
  },

  created() {
    // this.$emit("onInit", this.fields);
    Object.keys(this.fields).forEach(name => {
      this.$watch(() => this.fields[name].value, (newValue, oldValue) => {
        this.$emit("onChange", {
          name,
          new: newValue,
          old: oldValue,
          fields: this.fields
        });
      }, {
        deep: true
      });
    });
  },

  methods: {
    validate() {
      this.error = false;

      for (let field in this.fields) {
        this.fields[field].error = false;

        for (let rule of this.fields[field].rules) {
          if (isFunction(rule) && !rule(this.fields[field].value) || validators[rule] && !validators[rule](this.fields[field].value)) {
            this.fields[field].error = true;
            this.error = true;
            break;
          }
        }
      }

      return !this.error;
    },

    submit() {
      this.validate();
      this.$emit("onSubmit", {
        error: this.error,
        fields: this.fields
      });
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/index.js

// EXTERNAL MODULE: ./src/assets/css/robonomics.min.css
var robonomics_min = __webpack_require__("13be");

// CONCATENATED MODULE: ./src/lib.js






function install(Vue, options = {
  prefix: "R"
}) {
  for (const key in components) {
    const component = components[key];
    Vue.component(options.prefix ? options.prefix + key : key, component);
  }
} // auto install


if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

/* harmony default export */ var lib = ({
  install,
  components: components,
  filters: filters_namespaceObject,
  mixins: mixins_namespaceObject,
  validators: validators
});
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (lib);



/***/ })

/******/ });
//# sourceMappingURL=robonomics-vc.common.js.map